import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(3),
  },
  alert: {
    marginBottom: theme.spacing(2.5),
  },
  fieldsContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  fieldWrapper: {
    marginBottom: theme.spacing(2),
    
    // Sobrescrever propriedades do TextField para travar em Light Mode
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      backgroundColor: '#FCFCFC',
      color: '#1E293B !important', // Força cor do texto digitado escura
      transition: 'all 0.2s ease-in-out',
      
      // Borda padrão
      '& fieldset': {
        borderColor: 'rgba(0, 0, 0, 0.23) !important',
      },
      // Borda em hover
      '&:hover fieldset': {
        borderColor: 'rgba(0, 0, 0, 0.87) !important',
      },
      // Borda em foco
      '&.Mui-focused fieldset': {
        borderColor: '#0284C7 !important',
      },
      // Efeito de sombra no foco
      '&.Mui-focused': {
        backgroundColor: '#FFFFFF',
        boxShadow: '0 0 0 3px rgba(14, 165, 233, 0.2)',
      }
    },
    
    // Altura e espaçamentos internos dos inputs
    '& .MuiOutlinedInput-input': {
      padding: '14.5px 14px',
    },
    
    // Estilos da Label
    '& .MuiInputLabel-outlined': {
      color: '#64748B !important', // Força label cinza escuro
      transform: 'translate(40px, 15px) scale(1)', // Deslocado para a direita para não sobrepor o ícone do adorno
      
      // Label encolhida (quando focada ou preenchida)
      '&.MuiInputLabel-shrink': {
        transform: 'translate(14px, -6px) scale(0.75) !important', // Volta para a posição padrão do outline no canto superior esquerdo
      },
      // Label em foco
      '&.Mui-focused': {
        color: '#0284C7 !important',
      }
    }
  },
  submitButton: {
    marginTop: theme.spacing(1),
    width: '100%',
    padding: '12px 24px !important',
    fontSize: '0.95rem !important',
    fontWeight: '600 !important',
    borderRadius: '8px !important',
    boxShadow: 'none !important',
    backgroundColor: '#0A2540 !important', // Sempre Midnight Navy
    color: '#FFFFFF !important', // Sempre texto branco
    transition: 'all 0.2s ease-in-out !important',
    '&:hover': {
      backgroundColor: '#051221 !important', // Sempre Midnight Navy Escuro
      boxShadow: '0 4px 12px rgba(10, 37, 64, 0.2) !important',
      transform: 'translateY(-1px) !important',
    },
    '&:active': {
      transform: 'translateY(0) !important',
    },
    '&.Mui-disabled': {
      backgroundColor: 'rgba(0, 0, 0, 0.12) !important',
      color: 'rgba(0, 0, 0, 0.26) !important',
      boxShadow: 'none !important',
      transform: 'none !important',
    }
  },
  iconAdornment: {
    color: '#64748B', // Ícones decorativos cinza fixo
    marginRight: theme.spacing(1),
  },
  passwordToggle: {
    padding: 8,
    color: '#64748B', // Olho de visualização de senha cinza fixo
  }
}))

export default useStyles
export const styles = {}
